module.exports = __webpack_public_path__ + "static/searchFormDashBack-1e6c5aa340089ec7eabfa3f235ceef8a.png";